import {
  WizBasePopUp,
  WizDatasource,
  WizDateField,
  WizDropdown,
  WizTextarea,
} from '@wizeoo/akm-component-lib';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { FakeVO } from '../../../../../vo/common/tool/fake.vo';
import { ViewData } from '../../../../../model/view.data';
import { Model } from '../../../../../model/model';
import { WorkcomParameters, WorkComReply, WorkComVO } from '@wizeoo/akm-compute-lib';
import { WizDateUtils } from '@wizeoo/akm-core-lib';
import { WorkflowEngine } from '../../../../../manager/workflow/workflow.engine';


@Component({
  // popUp d'édition des cellules de type workflow
  selector: 'workcom-message-pop',
  templateUrl: './workcom-message.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkcomMessagePop extends WizBasePopUp {

  @ViewChild('taContent', { read: WizTextarea }) taContent: WizTextarea; 
  @ViewChild('ddState', { read: WizDropdown }) ddState: WizDropdown;
  @ViewChild('daStart', { read: WizDateField }) public daStart: WizDateField;
  @ViewChild('daEnd', { read: WizDateField }) public daEnd: WizDateField;
 

  public static baseWidth: number = 300;
  public static baseHeight: number = 300;

  private get model(): Model {
    return this.datas[0] as Model;
  }
  /** accesseur avec cast */
  private get clone(): WorkComVO {
    return this.datas[1] as WorkComVO;
  }

  public existWCR: WorkComReply = null;

  public stateDS: WizDatasource<FakeVO> = new WizDatasource<FakeVO>(ViewData.getInstance().workflowState)
    .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
    .build();

  public show(): void {
    // console.log('WorkcomMessagePop onshow', this.clone);
    this.feedWorkCom();
  }

  public feedWorkCom(): void {
    
    if(this.datas[2]) {
      this.existWCR = this.datas[2].wcr;
    }

    if(this.existWCR) {
      this.taContent.wizValue = this.existWCR.content;
      if(this.existWCR.startDate) {
        this.daStart.wizNumberValue = this.existWCR.startDate;
      }
      if(this.existWCR.endDate) {
        this.daEnd.wizNumberValue = this.existWCR.endDate;
      }

      let stateVO: FakeVO = null;
      if(this.existWCR.state) {
        stateVO = this.stateDS.getItemByKey(this.existWCR.state);
      }
      this.stateDS.select([stateVO]);


    } else {



      this.taContent.wizValue = "";

      let baseWcr: WorkComReply = WorkflowEngine.replyFromWC(this.clone);

      let idx: number = 0;
      if(this.clone?.params?.replies) {
        this.clone.params.replies.forEach(wcr => {
          if(wcr.idx > idx) {
            idx = wcr.idx;
            baseWcr = wcr;
          }
        });
      }


      if(baseWcr?.startDate) {
        this.daStart.wizNumberValue = baseWcr.startDate;
      }
      if(baseWcr?.endDate) {
        this.daEnd.wizNumberValue = baseWcr.endDate;
      }

      let stateVO: FakeVO = null;
      if(baseWcr?.state) {
        stateVO = this.stateDS.getItemByKey(baseWcr.state);
      }
      this.stateDS.select([stateVO]);
    }

    this.ddState.wizDataProvider = this.stateDS; // alimentation de la drop des types de données

    
  }

  public cancel(): void {
    this.hide();
  }

  public save(): void {
    
    let rendererCallback: Function = null;
    if(this.existWCR) {
      this.existWCR.content = this.taContent.wizValue;
      this.existWCR.date = WizDateUtils.NOW();
      this.existWCR.startDate = this.daStart.wizNumberValue || null;
      this.existWCR.endDate = this.daEnd.wizNumberValue || null;
      this.existWCR.state = this.stateDS.selectedItem?.code || null;
      rendererCallback = this.datas[2].callback;
    } else {
      let idx: number = -1;
      this.existWCR = {
        idx, 
        content: this.taContent.wizValue, 
        date: WizDateUtils.NOW(), 
        who: this.model.connectedUser.mail,
        startDate : this.daStart.wizNumberValue || null,
        endDate : this.daEnd.wizNumberValue || null,
        state: this.stateDS.selectedItem?.code || null
      };
    }
    


    this.callback(this.existWCR, rendererCallback);
    this.hide()
  }
}
